import ScheduleSettings from './components/ScheduleSettings';

export default ScheduleSettings;
